var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A6DFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,64c-64.7,0-117.3,52.7-117.3,117.3S191.3,298.7,256,298.7S373.3,246,373.3,181.3S320.7,64,256,64z  M298.7,192h-85.3c-5.9,0-10.7-4.8-10.7-10.7s4.8-10.7,10.7-10.7h85.3c5.9,0,10.7,4.8,10.7,10.7S304.6,192,298.7,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.7,319.1c38.9-33.3,63.7-82.6,63.7-137.7C437.3,81.3,356,0,256,0S74.7,81.3,74.7,181.3 c0,55.1,24.8,104.4,63.7,137.7L75.3,497.8c-1.4,4.1-0.3,8.7,3,11.5c2,1.7,4.5,2.7,7.1,2.7c1.6,0,3.2-0.4,4.8-1.1l79.2-39.6 l48,38.4c2.9,2.3,6.7,2.9,10.2,1.7c3.5-1.2,6.1-4.1,6.9-7.7l14.7-66.3l29,68.2c1.3,3.1,4,5.4,7.2,6.2c3.2,0.9,6.7,0.1,9.3-2 l48-38.4l79.2,39.6c1.5,0.7,3.1,1.1,4.7,1.1c2.5,0,5.1-0.9,7.1-2.7c3.2-2.9,4.4-7.5,3-11.5L373.7,319.1z M307.8,332.6l-33,7.6 c-6.1,0.7-12.4,1.2-18.7,1.2c-88.2,0-160-71.8-160-160s71.8-160,160-160s160,71.8,160,160C416,251.4,370.7,311,307.8,332.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContestIcon);
export default __webpack_public_path__ + "static/media/contest_icon.9843408d7a4a6e9b7da50905d8271b66.svg";
export { ForwardRef as ReactComponent };